export enum ForwardEntityTypeEnum {
    ticket = 1,
    reply = 2,
    ticketMessage = 3,
    attachment = 4,
}
